<template>
  <div class="full-text-editor">
    <el-form ref="form" :model="form" label-width="80px" label-position="left">
      <el-form-item :label="$t('microSite.common.form.title')">
        <el-input v-model="form.title" :placeholder="$t('microSite.common.form.titlePlaceholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.common.form.subtitle')">
        <el-input v-model="form.subTitle" :placeholder="$t('microSite.common.form.subtitlePlaceholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.common.form.content')">
        <quill-editor ref="quillEditor" v-model="form.content" :options="quillEditorOption"></quill-editor>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import editorTemplate from '../editorTemplate'
import { microSiteCommonOption } from '@/utils/quillEditor'
import Quill from 'quill'
import _ from 'lodash'

export default {
  mixins: [editorTemplate],
  data () {
    return {
      quillEditorOption: microSiteCommonOption,
      form: {
        title: null,
        subTitle: null,
        content: null
      }
    }
  },
  computed: {
  },
  created () {
    const props = this.renderData.data.props
    this.form.title = props.title
    this.form.subTitle = props.subTitle
    this.form.content = props.content
    const alignAttributor = Quill.import('attributors/class/align')
    alignAttributor.whitelist = [
      ...alignAttributor.whitelist,
      'left'
    ]
    Quill.register(alignAttributor, true)
    const fontSizeStyle = Quill.import('attributors/style/size')
    fontSizeStyle.whitelist = ['8px', '10px', '12px', '14px', '16px', '20px', '24px', '36px']
    Quill.register(fontSizeStyle, true)
  },
  mounted () {
    const quill = this.$refs.quillEditor.quill
    quill.getModule('toolbar').addHandler('align', function (value) {
      this.quill.format('align', value || 'left')
    })
    const targetSize = '12px'
    quill.format('size', targetSize)
    const toolbar = quill.getModule('toolbar')
    const sizePicker = toolbar.container.querySelector('.ql-size')
    if (sizePicker) {
      _.forEach(sizePicker.querySelectorAll('.ql-picker-item'), item => {
        item.classList.remove('ql-selected')
      })
      const targetItem = sizePicker.querySelector(`[data-value="${targetSize}"]`)
      if (targetItem) {
        targetItem.classList.add('ql-selected')
        const label = sizePicker.querySelector('.ql-picker-label')
        if (label) {
          label.setAttribute('data-value', targetSize)
        }
      }
    }
  },
  methods: {
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.title
      props.subTitle = this.form.subTitle
      props.content = this.form.content
      this.updateConfigInRoot()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.full-text-editor {
  ::v-deep .quill-editor {
    font-size: 14px;
    line-height: normal;

    div, input {
      font-size: 14px;
    }

    .ql-container {
      height: 120px;
    }

    .ql-snow {
      .ql-size {
        .ql-picker-label,
        .ql-picker-item {
          &::before {
            content: attr(data-value);
          }
        }
      }
    }
  }
}
</style>
